import { render, staticRenderFns } from "./CreateImaginaryCompanyDetails.vue?vue&type=template&id=6c189aa0&scoped=true"
import script from "./CreateImaginaryCompanyDetails.vue?vue&type=script&lang=js"
export * from "./CreateImaginaryCompanyDetails.vue?vue&type=script&lang=js"
import style0 from "./CreateImaginaryCompanyDetails.vue?vue&type=style&index=0&id=6c189aa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c189aa0",
  null
  
)

export default component.exports